import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import {
  ParcelsPreviewComponent
} from '../../../../../common/components/parcels/parcels-preview/parcels-preview.component';
import {
  LocationOfDevicesUnrelatedToRoadStageTableComponent
} from '../location-of-devices-unrelated-to-road-stage-table/location-of-devices-unrelated-to-road-stage-table.component';
import {
  LocationOfDevicesUnrelatedToRoadOccupationFormValue
} from '../../forms/location-of-devices-unrelated-to-road-occupation.form';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-occupation-preview',
  standalone: true,
  imports: [
    DatePipe,
    LabelComponent,
    ParcelsPreviewComponent,
    LocationOfDevicesUnrelatedToRoadStageTableComponent
  ],
  templateUrl: './location-of-devices-unrelated-to-road-occupation-preview.component.html'
})
export class LocationOfDevicesUnrelatedToRoadOccupationPreviewComponent {
  @Input()
  public occupation: LocationOfDevicesUnrelatedToRoadOccupationFormValue | undefined;
}
